var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreeDotsOrange(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.75C4.30964 8.75 3.75 9.30967 3.75 10C3.75 10.6903 4.30964 11.25 5 11.25C5.69036 11.25 6.25 10.6903 6.25 10C6.25 9.30967 5.69036 8.75 5 8.75Z",
    fill: "#F77E0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 10C8.75 9.30967 9.30967 8.75 10 8.75C10.6903 8.75 11.25 9.30967 11.25 10C11.25 10.6903 10.6903 11.25 10 11.25C9.30967 11.25 8.75 10.6903 8.75 10Z",
    fill: "#F77E0B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 10C13.75 9.30967 14.3097 8.75 15 8.75C15.6903 8.75 16.25 9.30967 16.25 10C16.25 10.6903 15.6903 11.25 15 11.25C14.3097 11.25 13.75 10.6903 13.75 10Z",
    fill: "#F77E0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotsOrange);
export default __webpack_public_path__ + "static/media/threeDotsOrange.ca2731673ef23ccb1a11226d03765820.svg";
export { ForwardRef as ReactComponent };